import { List } from '@acciona/ui-ionic-kit';

export const DetailList: React.FC<any> = props => {
  return <List className={props.className}>{props.children}</List>;
};
